import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import FeatureBento from "@/components/sections/FeatureBento";
import IndustriesGrid from "@/components/sections/IndustriesGrid";
import FAQAccordion from "@/components/sections/FAQAccordion";
import LocalizationStrip from "@/components/sections/LocalizationStrip";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const whys = [
  { t: "Built for every workforce", d: "Office, remote, hybrid, shift-based, and field teams — one platform for all." },
  { t: "Configuration over customization", d: "A powerful rules engine handles most business logic without a single line of code." },
  { t: "Employee-first experience", d: "Modern web and native mobile apps that employees actually adopt." },
  { t: "Enterprise-grade security", d: "MFA, tenant isolation, feature-level access control, and full audit trails." },
  { t: "Rapid implementation", d: "Go live in days — not months — with white-glove data migration." },
  { t: "Custom development, built in", d: "Have a unique workflow? We build to fit — and it scales with you." },
];

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <LocalizationStrip />
      <Stats />
      <FeatureBento />

      {/* Why ClockedIn */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-14">
            <div className="lg:col-span-4">
              <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-3">Why ClockedIn</div>
              <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter text-[#1F1E4E]">
                The details that make it a joy to run HR.
              </h2>
              <p className="mt-6 text-slate-600 leading-relaxed">
                We built ClockedIn HRM by studying what actually slows HR teams down. Every module solves a real pain — not a checkbox.
              </p>
              <Link to="/features" className="inline-flex items-center gap-2 mt-8 bg-[#1F1E4E] hover:bg-[#2A2960] text-white font-bold rounded-lg px-6 py-3 transition-colors" data-testid="why-cta-btn">
                See every feature
              </Link>
            </div>
            <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5">
              {whys.map((w, i) => (
                <div key={i} className="p-6 rounded-2xl border border-slate-200 hover:border-[#00A651] hover:bg-[#00A651]/[0.02] transition-all">
                  <CheckCircle2 className="h-5 w-5 text-[#00A651] mb-4" />
                  <div className="font-extrabold text-[#1F1E4E]">{w.t}</div>
                  <div className="text-sm text-slate-500 mt-2 leading-relaxed">{w.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <IndustriesGrid />

      {/* FAQ */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-3">Questions</div>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter text-[#1F1E4E]">Frequently asked</h2>
          </div>
          <FAQAccordion limit={8} />
          <div className="text-center mt-10">
            <Link to="/faq" className="text-sm font-bold text-[#00A651] hover:underline">View all 50+ questions →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
